import React from "react";
import { Check } from "lucide-react";
import Reveal from "../Reveal";

const ProgramCard = ({ prog }) => (
  <Reveal>
    <div className="bg-white rounded-sm shadow-[0_20px_50px_-30px_rgba(58,55,54,0.4)] overflow-hidden">
      <div className="bg-[#b6a4a7] px-8 py-6">
        <h3 className="brand-title text-3xl md:text-4xl text-white uppercase">{prog.name}</h3>
        <p className="font-serif-el italic text-white/90 text-lg mt-1">{prog.tagline}</p>
      </div>
      <div className="px-8 py-8">
        <p className="font-serif-el text-lg leading-relaxed text-[#4a4644] mb-8">{prog.intro}</p>
        <div className="grid md:grid-cols-2 gap-8">
          {prog.groups.map((g) => (
            <div key={g.heading}>
              <h4 className="font-sans-el tracking-[0.2em] uppercase text-[#6f5f62] text-sm mb-4">
                {g.heading}
              </h4>
              <ul className="space-y-3">
                {g.items.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <Check size={17} className="text-[#b6a4a7] mt-1 shrink-0" />
                    <span className="font-sans-el text-[#4a4644] leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="font-serif-el text-lg italic text-[#3a3736] mt-8 pt-6 border-t border-[#eae2d9]">
          {prog.cta}
        </p>
      </div>
    </div>
  </Reveal>
);

export default ProgramCard;
